module.exports = __webpack_public_path__ + "static/media/handshake.95c97ae4.svg";